import { colors } from "@toddle-edu/ds-theme";
import {
  MYP_INTERDISCIPLINARY,
  PYP_TRANSDISCIPLINARY,
  UBD_INQUIRY,
  CURRICULUM_TYPE_MYP,
  CURRICULUM_TYPE_UBD,
  CURRICULUM_TYPE_PYP,
} from "Constants/stringConstants";

// fields for which add block action should be visible

export const EMOJI_COLOR_TRAY = [
  colors.pink950,
  colors.orange950,
  colors.green950,
  colors.yellow950,
];

export const DIALOGS_INFO = {
  CLEAR_CHAT: {
    title: ({ t }) => t("classRoom:clear_chat"),
    message: ({ t }) => t("classRoom:clear_chat_history_msg"),
    buttonOneText: ({ t }) => t("common:cancel"),
    buttonTwoText: ({ t }) => t("common:clear"),
  },
  CLEAR_CHAT_AND_GENERATE: {
    title: ({ t }) => t("ai:clear_chat_with_question_mark"),
    message: ({ t }) => t("ai:selecting_a_new_prompt_warning_msg"),
    buttonOneText: ({ t }) => t("ai:go_back_to_library"),
    buttonTwoText: ({ t }) => t("ai:clear_chat_and_generate"),
    showDoNotShowThisAgain: true,
    width: "456px",
  },
  REPLACE_CONTENT: {
    title: ({ t, label }) =>
      t("common:replace_with_label", {
        label,
      }),
    message: ({ t, label }) =>
      t("classRoom:replace_block_content_msg", {
        label,
      }),
    buttonOneText: ({ t }) => t("common:cancel"),
    buttonTwoText: ({ t, label }) => t("classRoom:add_to_label", { label }),
    showDoNotShowThisAgain: true,
  },
  REPLACE_CONTENT_MYP_RUBRIC: {
    title: ({ t, label }) =>
      t("common:replace_with_label", {
        label,
      }),
    message: ({ t, label }) =>
      t("classRoom:replace_block_content_msg", {
        label,
      }),
    buttonOneText: ({ t }) => t("common:cancel"),
    buttonTwoText: ({ t, label }) => t("classRoom:add_to_label", { label }),
    width: "520px",
  },
};

export const INTERDISCIPLINARY_FIELD_MAPPING = {
  learningStandardMYP: "disciplinaryLearningStandardMYP",
  objectivesMYP: "disciplinaryObjectivesMYP",
  relatedConceptsMYP: "disciplinaryRelatedConceptsMYP",
  content: "disciplinaryContent",
};

export const LOCAL_CONTEXT = ["location", "textTitles", "twoTextTitles"];
export const MYP_OBJECTIVES = ["objectivesMYP", "interdisciplinaryCriteriaMYP"];

export const ELEMENT_TYPE_ADD_LEARNING_GOALS = "AddLearningGoals";

export const INTERDISCIPLINARY_UNIT_TYPES = {
  [CURRICULUM_TYPE_MYP]: MYP_INTERDISCIPLINARY,
  [CURRICULUM_TYPE_PYP]: PYP_TRANSDISCIPLINARY,
  [CURRICULUM_TYPE_UBD]: UBD_INQUIRY,
};

export const SUBJECTS_TO_CONSIDER_AS_LANGUAGE = ["Classical Greek", "Latin"];

export const INITIAL_STATE = {
  DIALOG_ACTION: {
    action: "",
    params: {
      isChecked: false,
    },
  },
  PROMPT_SUGGESTION_MODAL_INFO: {
    showModal: false,
    params: {},
  },
};

export const ATTACHMENT_PICK_KEYS = [
  "id",
  "name",
  "type",
  "mimeType",
  "url",
  "thumbUrl",
  "title",
  "metadata",
  "parentType",
  "modalityAttachment",
];
